export * from "./auth.interface";
export * from "./global.interface";

export enum UserRoles {
  OPERATIONS = "OPERATIONS",
  VIEWER = "VIEWER",
  SUBUSER = "SUBUSER",
  ADMIN = "ADMIN",
  SUPERADMIN = "SUPERADMIN",
}
